import { ACTIONS } from '../const';
import objectRecord from './object_record';

const meta = objectRecord({
    next: null,
    total_count: 0,
});
const criteriaRecord = objectRecord({
    queryText: '',
    context: null,
});

const doctypeResults = objectRecord({
    meta: meta(),
    results: [],
});

const stateRecord = objectRecord({
    criteria: criteriaRecord(),
    loading: false,
    doctypes: {},
});

const resultRecord = objectRecord({
    author: null,
    author_name: null,
    chapter_name: null,
    color: null,
    content: null,
    content_title: null,
    created: null,
    doctype: null,
    domain: null,
    highlighted: null,
    modified: null,
    note_text: null,
    owner: null,
    owner_name: null,
    page: null,
    page_label: null,
    resource_uri: null,
    section: null,
    section_title: null,
    slug: null,
    tags: null,
    title: null,
});

function isValidResult(result) {
    return result.content != null;
}

const defaultState = stateRecord();

export const defaultDoctypeResults = doctypeResults();
function doctypeReducer(state = defaultDoctypeResults, action) {
    const {
        payload: { blob },
    } = action;

    const newResults = blob.objects.map(resultRecord).filter(isValidResult);

    return doctypeResults(state, {
        meta: meta(blob.meta),
        results: state.results.concat(newResults),
    });
}

export default function reducer(state = defaultState, action) {
    const { type, payload } = action;
    const { criteria } = state;

    switch (type) {
        case ACTIONS.SEARCH:
            // Don't merge with the old state, just return a new state
            return stateRecord({
                loading: true,
                criteria: {
                    queryText: action.payload.queryText,
                    context: action.payload.context,
                },
            });

        case ACTIONS.SEARCH_RESULTS:
            if (
                payload.queryText !== criteria.queryText ||
                payload.context !== criteria.context
            ) {
                // ignore delayed results
                return state;
            }

            return stateRecord(state, {
                doctypes: {
                    ...state.doctypes,
                    [payload.doctype]: doctypeReducer(
                        state.doctypes[payload.doctype],
                        action
                    ),
                },
            });
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/search.js